import React from 'react';
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  CircularProgress,
  Chip,
} from '@mui/material';
import dayjs from 'dayjs';

const ShiftUserList = ({ usersInShift, usersInShiftLoading, selectedShift, Languages }) => {
  if (usersInShiftLoading) {
    return (
      <Box display="flex" justifyContent="center" my={4}>
        <CircularProgress />
      </Box>
    );
  }

  if (usersInShift.length === 0) {
    return (
      <Typography variant="body1" color="text.secondary" align="center" my={4}>
        No agents available for this shift
      </Typography>
    );
  }

  return (
    <Grid container spacing={2}>
      {usersInShift.map((userShift) => (
        <Grid item xs={12} sm={6} md={4} key={userShift._id}>
          <Card variant="outlined" sx={{ height: '100%' }}>
            <CardContent>
              <Typography variant="h6" component="div">
                {userShift.name || 'Unnamed Agent'}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {userShift.email || 'No email'}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Status: {userShift.status || 'Unknown'}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Allocated: {userShift.allocated || 0}/{selectedShift[Object.keys(selectedShift)[0]].number || '∞'}
              </Typography>
              {userShift.languages && userShift.languages.length > 0 && Languages && (
                <Box mt={1} sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                  {userShift.languages.map(langId => {
                    const lang = Languages.find(l => l._id === langId);
                    return lang ? (
                      <Box
                        key={langId}
                        sx={{
                          bgcolor: 'primary.main',
                          color: 'primary.contrastText',
                          fontSize: '0.7rem',
                          borderRadius: '12px',
                          px: 1,
                          py: 0.25,
                          display: 'inline-block'
                        }}
                      >
                        {lang.name}
                      </Box>
                    ) : null;
                  })}
                </Box>
              )}
              {userShift.leaveRequest && (
                <Box mt={1}>
                  <Chip 
                    label={`Leave: ${userShift.leaveRequest.approved ? 'Approved' : 'Pending'}`}
                    color={userShift.leaveRequest.approved === "Approved" ? 'success' : 'warning'}
                    size="small"
                    sx={{ mb: 1 }}
                  />
                  <Typography variant="caption" component="div" color="text.secondary">
                    {dayjs(userShift.leaveRequest.from).format('MMM D, YYYY')} - 
                    {dayjs(userShift.leaveRequest.to).format('MMM D, YYYY')}
                  </Typography>
                  <Typography variant="caption" component="div" color="text.secondary">
                    {dayjs(userShift.leaveRequest.to).diff(dayjs(userShift.leaveRequest.from), 'day') + 1} days
                  </Typography>
                </Box>
              )}
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default ShiftUserList;
